import React, { useEffect, useState } from "react";
import { Section, Chip } from "@/growth/components/_ui";
import * as gc from "@/growth/api";

export default function AuditLogTab({ wsId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    gc.auditLog(wsId).then((r) => setRows(r.items || []));
  }, [wsId]);
  return (
    <Section title="Audit Log" subtitle="Immutable record of every event in this workspace — created, saved, approved, decided.">
      {rows.length === 0 ? <p className="text-sm text-slate-500">No events yet.</p> : (
        <div className="space-y-2">
          {rows.map((e) => (
            <div key={e.id} className="flex items-center gap-3 border border-slate-200 rounded-xl px-3 py-2 bg-white" data-testid={`gc-log-${e.id}`}>
              <Chip tone="slate">{e.event}</Chip>
              <div className="text-sm text-slate-700 flex-1">{e.actor}</div>
              <div className="text-xs text-slate-500">{new Date(e.at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
